import { content } from "../../constants/tariffTile";
import { useIsMobile } from "../../hooks/useIsMobile";
export var getCompactParameterPictureSrc = function getCompactParameterPictureSrc(parameter) {
  return parameter.icon.includes('.') || parameter.icon.includes('/') ? parameter.icon : "//static.beeline.ru/upload/images/icons/alive-ruler-icons/".concat(parameter.icon, ".svg");
};
export var getLinkTextByConditions = function getLinkTextByConditions(_ref) {
  var isConstructor = _ref.isConstructor;
  if (isConstructor) {
    return content.link.constructorText;
  }
  return content.link.text;
};
export var usePrepareDefault = function usePrepareDefault(props) {
  var isMobile = useIsMobile();
  var showBtn = !!props.link && !isMobile;
  var labelSize = isMobile ? 'xs' : 's';
  var showWait = props.isLoading || props.isError;
  var hasLabel = !!props.discount || props.isConnected;
  var showContent = !props.isLoading && !props.isError;
  var showTopParameters = props.topParameters && props.topParameters.length > 0;
  var showCompactParameters = props.compactParameters && props.compactParameters.length > 0;
  return {
    showBtn: showBtn,
    labelSize: labelSize,
    showWait: showWait,
    hasLabel: hasLabel,
    showContent: showContent,
    showTopParameters: showTopParameters,
    showCompactParameters: showCompactParameters
  };
};